import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CheckIcon from '@mui/icons-material/CheckRounded';
import ClearIcon from '@mui/icons-material/ClearRounded';
import {setFormValueByElement} from '../../../utils/Utils'
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import InputAdornment from '@mui/material/InputAdornment';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDownRounded';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUpRounded';

export default function SelectFieldForm(props) {
    let defaultValue = props.defaultValue;
    const [changed, setChanged] = useState(false);
    const [value, setValue] = useState();
    const [anchorEl, setAnchorEl] = useState();    
    const [width, setWidth] = useState();
    const valueRef = useRef();
    
    const keyField = props.keyField || 'id'
    
    const saveHandler = () => {
        props.onSave(value);
        setValue(value);
        defaultValue = value;
        setChanged(false);
    }
    
    const cancelHandler = () => {
        setValue(defaultValue);
        getOptionName(defaultValue);
        setChanged(false);
    }
    
    const itemClickHandler = (row) => {
        setAnchorEl(null);
        setFormValueByElement(valueRef.current, row.name)
        setValue(row[keyField])
        setChanged(true);
    }
    
    const getOptionName = (id) => {
        if (!props.options) {
            return '';
        }
        for (let i = 0; i < props.options.length; i++) {
            if (props.options[i][keyField] == id) {
                setFormValueByElement(valueRef.current, props.options[i].name)
                break;
            }
        }
    }
    
    useEffect(() => {
        getOptionName(defaultValue)
        setValue(defaultValue)
    }, [props.options, defaultValue])
        
    useLayoutEffect(() => {
        setWidth(valueRef.current.offsetWidth + 30);
    })    
    
    return (
        <Stack direction="row" spacing={1}>
            <TextField
                sx={{width:'100%', input: { cursor: 'pointer' }}}
                variant="standard"
                label={props.label}
                defaultValue={value ? value : 'Select'}
                inputRef={valueRef}
                onClick={(e) => {setAnchorEl(e.currentTarget)}}
                InputProps={{
                    readOnly: true,
                    endAdornment:
                        <InputAdornment position="end" sx={{ cursor: 'pointer' }}>
                            {anchorEl ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                        </InputAdornment>
                }}
            />
            <Popover
                id="popover"
                open={anchorEl ? true : false}
                anchorEl={anchorEl}
                onClose={() => {setAnchorEl(null) }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                PaperProps={{
                    style: { minWidth: width, maxWidth: width },
                }}
            >
                {
                    props.options?.map((row, key) => (
                        <MenuItem key={key} value={row[keyField]} onClick={() => {itemClickHandler(row)}}>{row.name}</MenuItem>
                    ))
                }
            </Popover>
            {changed ?
            <Stack direction="row" sx={{paddingTop:1.5, marginBottom:-1.5}}>
                <IconButton color="success" size="medium" onClick={saveHandler}>
                    <Tooltip title="Save">
                        <CheckIcon />
                    </Tooltip>
                </IconButton>
                <IconButton color="warning" size="medium" onClick={cancelHandler}>
                    <Tooltip title="Cancel">
                        <ClearIcon />
                    </Tooltip>
                </IconButton>
            </Stack>
            : null }
        </Stack>
    );
}